import React from 'react';
import I18n from 'i18n-js';
import PropTypes from 'prop-types';
import SelectField from 'components/v2/select-field/select-field';

const localeKeyPrefix = 'shopify.settings.basicSettingsSection.form';

export const ProductCategoryField = props => {
  const { initialValue, ...other } = props;

  return (
    <SelectField
      {...other}
      placeholder={`${I18n.t(
        `${localeKeyPrefix}.placeholder.productCategory`,
      )}*`}
      options={props.productCategoryOptions}
      fieldOptions={{
        initialValue,
        rules: [
          {
            required: true,
            message: I18n.t(
              `${localeKeyPrefix}.validation.productCategoryRequired`,
            ),
          },
        ],
      }}
    />
  );
};

ProductCategoryField.propTypes = {
  id: PropTypes.string.isRequired,
  form: PropTypes.shape({}).isRequired,
  initialValue: PropTypes.string,
  disabled: PropTypes.bool,
  productCategoryOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

ProductCategoryField.defaultProps = {
  initialValue: '',
  disabled: false,
};

export default ProductCategoryField;
